import AbstractProductType from './AbstractProductType'
import { ProductTypeFormat } from './types'

export default class SelfCoveredOversized extends AbstractProductType {

  name = 'self_covered_oversized'
  title = 'Self Covered Oversized'

  oversized = true

  format = ProductTypeFormat.Covered

}
